module.exports = __webpack_public_path__ + "static/media/imagemMaoEsquerda.391da15f.png";